import React from "react";
import { Form } from "react-bootstrap";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Orange_btn from "../../../../../../common_components/common_btn/orange_btn/Orange_btn";

function Step8({ onNext, onBack }) {
  return (
    <>
      <div className="mt-4 card_box">
        <div className="heading_text_holder">
          <h1>
            Complete with subjunctive: 'Although it _____ late, I'm working.
          </h1>
        </div>

        <Form className="mt-3 lt_options">
          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              name="q8"
              label="Is"
              className="lt_option"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              name="q8"
              label="Be (subj.)"
              className="lt_option"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              name="q8"
              label="Will be"
              className="lt_option"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              name="q8"
              label="Would be"
              className="lt_option"
            />
          </Form.Group>
        </Form>

        {/* Buttons */}
        <div className="btn_holder">
        <Orange_btn btn_text="Back" onClick={onBack} />
        <Blue_btn btn_text="Next" onClick={onNext} />
        </div>
      </div>
    </>
  );
}

export default Step8;
